function degToRad(degrees) {
  return degrees * (Math.PI / 180);
}

function calculateYSegment(latitude1, latitude2, radius) {
  const lat1Rad = degToRad(latitude1);
  const lat2Rad = degToRad(latitude2);

  return (lat2Rad - lat1Rad) * radius;
}

function calculateXSegment(longitude1, longitude2, latitude, radius) {
  const lon1Rad = degToRad(longitude1);
  const lon2Rad = degToRad(longitude2);
  const latRad = degToRad(latitude);

  return (lon2Rad - lon1Rad) * radius * Math.cos(latRad);
}

function calculateAreaInSquareMeters(x1, x2, y1, y2) {
  return (x1 * y2 - x2 * y1) / 2;
}

export function calculateArea(locations) {
  if (!locations || locations.length < 3) {
    return 0;
  }

  const radius = 6371000;

  const { latitude: latitudeRef, longitude: longitudeRef } = locations[0];

  const listX = [0];
  const listY = [0];

  for (let i = 1; i < locations.length; i++) {
    const { latitude, longitude } = locations[i];

    listY.push(calculateYSegment(latitudeRef, latitude, radius));

    listX.push(calculateXSegment(longitudeRef, longitude, latitudeRef, radius));
  }

  let areasSum = 0;

  for (let i = 0; i < listX.length; i++) {
    const nextIndex = (i + 1) % listX.length;

    areasSum += calculateAreaInSquareMeters(listX[i], listX[nextIndex], listY[i], listY[nextIndex]);
  }

  return Math.abs(areasSum);
}
